<template>
  <div class="table-region" v-loading="tableLoading">
    <el-table size="small" :data="tableData">
      <el-table-column v-for="col in columns" :key="col.prop" :label="col.label" :prop="col.prop" align="center"
        :min-width="col.minWidth" :show-overflow-tooltip="col.showOverflowTooltip">
        <template slot-scope="scope">
          <span :style="col.showOverflowTooltip ? 'cursor: pointer;' : ''" @click="handleCopy(scope.row, col)">
            {{ (scope.row[col.prop] || scope.row[col.prop] === 0) ? scope.row[col.prop] : '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150" class-name="small-padding fixed-width"
        v-if="actions && actions.length > 0">
        <template slot-scope="scope">
          <template v-for="(btn, index) in actions">
            <el-button size="small" :type="btn.type || 'text'" @click="handleAction(btn.value, scope.row)"
              v-if="btn.show ? btn.show(scope.row) : true" :key="index">
              {{ btn.label }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ListTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleAction(action, row) {
      this.$emit('action', action, row)
    },
    handleCopy(row, col) {
      if (col.showOverflowTooltip) {
        if (col.prop === 'link') {
          this.copyToClipboard(row.url)
        } else if (col.prop === 'goodsName') {
          this.copyToClipboard(row.commodityName)
        } else if (col.prop === 'name') {
          this.copyToClipboard(row.name)
        }
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(err => {
          this.$message.error('复制失败')
        })
      } else {
        // 兼容性兜底方案
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
        document.body.removeChild(textarea)
      }
    }
  }
}
</script>

<style scoped></style>
